<template>
    <div class="client_box">
        <van-nav-bar
                title="客服"

        />
        <div class="uni-order-name">
            <p>
                客服
            </p>
        </div>
        <div class="note-text ng-binding" style="text-align:center; margin-bottom: .8rem;">微信号:&nbsp;</div>
        <div>
            <img ng-src="http://cdn.aoshangbao.com.au/cmp/aoshang_cs_2.jpg" class="qr-code-img" style="max-width:120px"
                 src="http://cdn.aoshangbao.com.au/cmp/aoshang_cs_2.jpg">
        </div>
        <div class="note-text" style="text-align:center">--请长按图片,在微信弹出菜单中选择“识别图中二维码”--</div>
    </div>
</template>

<script>
    export default {
        name: "Client"
    }
</script>

<style scoped>
    .client_box {
        background: #fff;
        padding-bottom: 2rem;
        text-align: center;
    }
    .van-nav-bar {
        background: #387ef5;
        box-sizing: border-box;
    }

    .van-nav-bar__title {
        color: #ffffff;
    }

    .uni-order-name {
        text-align: left;
        padding: 0 10px;
    }

    .uni-order-name p {
        font-size: 16px;
        font-weight: bold;
        color: #576b95;
    }

    .note-text {
        font-size: 14px;
        color: #676a6c;
        word-wrap: break-word;
        white-space: normal;
    }

</style>